import { type FC, useMemo } from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../../Application/globaltypes/redux";
import CustomerPackReport from "./Customer/CustomerPackReport";
import SpPackReport from "./SolutionProvider/SpPackReport";
import { useAddOnQuery } from "../Content/queries/useAddOnQuery";
import { Loader } from "semantic-ui-react";
import { useFeatureFlag } from "hooks/useFeatureFlag";
import { FeatureFlags } from "featureFlags";
import { ReportUnavailable } from "components/reportUnavailable/ReportUnavailable";

import "./reportingPacks.scss";
import { AddOnIds } from "enums";
import PacksLicensingSegments from "./Segments/PacksLicensingSegments";

export const ReportingPacks: FC<PropsFromRedux> = ({ accountId }) => {
  const isPackTopLevelPerformanceEnabled = !!useFeatureFlag(FeatureFlags.PackTopLevelPerformance);
  const isPacksAndLicensingReportingEnabled = !!useFeatureFlag(FeatureFlags.PacksAndLicensingReporting);
  const { data: addons, isLoading } = useAddOnQuery(accountId);

  const body = useMemo(() => {
    if (isLoading) {
      return <Loader active />;
    }

    const hasCreateAccount = addons?.find((addon) => addon.id === AddOnIds.CreateAccounts)?.isEnabled;
    const hasMarketplace = addons?.find((addon) => addon.id === AddOnIds.Marketplace)?.isEnabled;

    if (hasCreateAccount || hasMarketplace) {
      return isPacksAndLicensingReportingEnabled ? <PacksLicensingSegments /> : <SpPackReport />;
    }

    return <CustomerPackReport />;
  }, [addons, isLoading, isPacksAndLicensingReportingEnabled]);

  if (!isPackTopLevelPerformanceEnabled) {
    return <ReportUnavailable />;
  }

  return <div className="nested-content reportingPacksRoot">{body}</div>;
};

const mapStateToProps = (state: RootState) => ({
  accountId: state.userProfile.accountId,
});

const connector = connect(mapStateToProps, {});
export type PropsFromRedux = ConnectedProps<typeof connector>;

const ConnectedComponent = connector(ReportingPacks);
export default ConnectedComponent;
